import Cookies from 'js-cookie';

const setLoginToken = (loginToken: string) => {
	Cookies.set('loginToken', loginToken, {expires: 1, secure: true});
};
const setAuthTokens = (accessToken: string, refreshToken: string) => {
	Cookies.set('accessToken', accessToken, {expires: 1, secure: true});
	Cookies.set('refreshToken', refreshToken, {expires: 7, secure: true});
};
const getLoginToken = () => Cookies.get('loginToken');
const getAccessToken = () => Cookies.get('accessToken');
const getRefreshToken = () => Cookies.get('refreshToken');
const removeAuthTokens = () => {
	Cookies.remove('loginToken');
	Cookies.remove('accessToken');
	Cookies.remove('refreshToken');
};

export {
	setLoginToken,
	setAuthTokens,
	getLoginToken,
	getAccessToken,
	getRefreshToken,
	removeAuthTokens,
};
